import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { PaymentSummary } = await import('@containers/Payment/PaymentSummary');
    return {
        Component: PaymentSummary,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
